import { PATH_HOME } from "../constants";

import { useIsPath } from "./use-is-path";

export const useIsDashboard = (): boolean => useIsPath(PATH_HOME);
